import { api } from './api';
import type {
  CreateWorkspaceCompanyInput,
  CreateWorkspaceCompanyResult,
  SetActiveWorkspaceInput,
  UpdateWorkspaceCompanyInput,
  UpdateWorkspaceCompanyResult,
  WorkspaceListResult,
} from '@tabbio/types';

export async function fetchWorkspaces(): Promise<WorkspaceListResult> {
  const res = await api.get<WorkspaceListResult>('/api/workspaces');
  if (res.error) throw new Error(res.error.message);
  return res.data ?? { workspaces: [], activeWorkspaceId: 'personal' };
}

export async function setActiveWorkspace(
  input: SetActiveWorkspaceInput,
): Promise<{ activeWorkspaceId: string }> {
  const res = await api.put<{ activeWorkspaceId: string }>('/api/workspaces/active', input);
  if (res.error) throw new Error(res.error.message);
  if (!res.data) throw new Error('Active workspace update returned no data');
  return res.data;
}

export async function createWorkspaceCompany(
  input: CreateWorkspaceCompanyInput,
): Promise<CreateWorkspaceCompanyResult> {
  const res = await api.post<CreateWorkspaceCompanyResult>('/api/workspaces/company', input);
  if (res.error) throw new Error(res.error.message);
  if (!res.data) throw new Error('Company workspace creation returned no data');
  return res.data;
}

export async function updateWorkspaceCompany(
  companyId: string,
  input: UpdateWorkspaceCompanyInput,
): Promise<UpdateWorkspaceCompanyResult> {
  const res = await api.patch<UpdateWorkspaceCompanyResult>(`/api/workspaces/company/${companyId}`, input);
  if (res.error) throw new Error(res.error.message);
  if (!res.data) throw new Error('Company workspace update returned no data');
  return res.data;
}
